import useLenis from "../components/useLenis";
import ContactHero from "./ContactHero";
import ContactForm from "./ContactForm";
import Footer from "../components/Home/Footer";

export default function ContactPage() {
  useLenis();
  return (
    <>
      <ContactHero />
      <ContactForm />
      <Footer />
    </>
  );
}
